import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@workflow/ecp-shared/service/user/user.service';
import { OLACustomPage } from '../custom-page.types';
import { CorePageBaseComponent } from '@workflow/dynamic-render/page/shared/core-page-base.component';
import { WorkflowPageNavigationService } from '@workflow/service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '@workflow/widget/workflow-widget-event.service';
import { StatefulService } from '@app/service/stateful.service';

@OLACustomPage('ola-interstitial')
@Component({
  selector: 'ecp-ola-interstitial',
  templateUrl: './ola-interstitial.component.html'
})
export class OlaInterstitialComponent extends CorePageBaseComponent {
  private readonly statefulService = inject(StatefulService);

  public interestialOptions = [
    {
      title: 'Start a new application',
      defaultValue: true,
      selected: false,
      storage: 'ola:olaApplicationInformation/isStartNewApplication'
    },
    {
      title: 'Continue an existing application',
      defaultValue: false,
      selected: false,
      storage: 'ola:olaApplicationInformation/isContinueExistingApplication'
    }
  ];

  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public readonly widgetEventService: WorkflowWidgetEventServiceService,
    public readonly userService: UserService,
    public router: Router
  ) {
    super(workflowPageNavigationService, widgetEventService);
  }

  public dontShowPageOnLogin(): boolean {
    return this.userService && this.userService.isAuthenticated ? false : true;
  }

  // eslint-disable-next-line @typescript-eslint/tslint/config, @angular-eslint/use-lifecycle-interface
  public ngOnInit(): void {
    if (this.dontShowPageOnLogin()) {
      this.interestialOptions.forEach((item, i) => {
        if (item.defaultValue) {
          this.setValue(i);
        }
      });
    } else {
      this.router.navigateByUrl(`/consumer/dashboard?return=dashboard`);
      return;
    }
  }

  public setValue(index): void {
    const obj = this.interestialOptions[index];

    if (obj && obj.storage) {
      obj.selected = true;
      this.statefulService.wrap(`${obj.storage}`).value = true;
    }

    // eslint-disable-next-line eqeqeq
    const otherItems = this.interestialOptions.filter((item, i) => i != index);
    otherItems.forEach((item) => {
      item.selected = false;
      this.statefulService.wrap(`${item.storage}`).value = false;
    });
  }

  public gotToOLANextPage(): void {
    const isContinueExistingApplication = this.statefulService.wrap(`ola:olaApplicationInformation/isContinueExistingApplication`).value;
    // Timeout to allow for field to blur and virtual keyboard to close on mobile
    // before landing on the next page so that scroll position does not persist
    setTimeout(() => {
      if (isContinueExistingApplication && this.page.helper.isPageComplete) {
        this.router.navigate(['/user/login'], { queryParams: { continue: true } });
      } else if (this.page.helper.isPageComplete && this.page.helper.hasNextPage) {
        this.workflowPageNavigationService.navigateNextPage();
      }
    }, 200);
  }
}
